import React from 'react';
import { CommonInput } from '@/components/ui/common-input';
import { CommonSelect } from '@/components/ui/common-select';

const DriverProfile = ({ 
  driverProfile, 
  transporterOptions, 
  loading, 
  errors, 
  onProfileChange,
  currentUserRole,
  currentUserId
}) => {
  const isTransporter = currentUserRole === 'transporter';
  
  const handleDateChange = (value) => {
    let sanitizedValue = value.replace(/[^\d]/g, '');
    
    let formattedValue = '';
    if (sanitizedValue.length >= 4) {
      formattedValue = sanitizedValue.substring(0, 4);
      if (sanitizedValue.length >= 6) {
        formattedValue += '/' + sanitizedValue.substring(4, 6);
        if (sanitizedValue.length >= 8) {
          formattedValue += '/' + sanitizedValue.substring(6, 8);
        } else if (sanitizedValue.length > 6) {
          formattedValue += '/' + sanitizedValue.substring(6);
        }
      } else if (sanitizedValue.length > 4) {
        formattedValue += '/' + sanitizedValue.substring(4);
      }
    } else {
      formattedValue = sanitizedValue;
    }
    
    onProfileChange('driver_profile', 'license_expiry', formattedValue);
  };
  
  const formatDateDisplay = (dateString) => {
    if (!dateString) return '';
    return dateString;
  };

  if (isTransporter && currentUserId) {
    return (
      <div className="">
        <div className="p-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <CommonInput
              label="License Number"
              id="license_number"
              value={driverProfile.license_number}
              onChange={(e) => onProfileChange('driver_profile', 'license_number', e.target.value)}
              error={errors.license_number}
              required
              placeholder="Enter license number"
            />
            <CommonInput
              label="License Expiry"
              id="license_expiry"
              value={formatDateDisplay(driverProfile.license_expiry)}
              onChange={(e) => handleDateChange(e.target.value)}
              error={errors.license_expiry}
              required
              placeholder="2025/12/31"
              maxLength="10"
            />
            <input 
              type="hidden" 
              value={currentUserId} 
              onChange={(e) => onProfileChange('driver_profile', 'transporter_id', e.target.value)}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <div className="p-1">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <CommonInput
            label="License Number"
            id="license_number"
            value={driverProfile.license_number}
            onChange={(e) => onProfileChange('driver_profile', 'license_number', e.target.value)}
            error={errors.license_number}
            required
            placeholder="Enter license number"
          />
          <CommonInput
            label="License Expiry"
            id="license_expiry"
            value={formatDateDisplay(driverProfile.license_expiry)}
            onChange={(e) => handleDateChange(e.target.value)}
            error={errors.license_expiry}
            required
            placeholder="2025/12/31"
            maxLength="10"
          />
          <div className="md:col-span-2">
            <CommonSelect
              label="Transporter"
              id="transporter_id"
              value={driverProfile.transporter_id}
              onValueChange={(value) => onProfileChange('driver_profile', 'transporter_id', value)}
              options={transporterOptions}
              error={errors.transporter_id}
              required
              placeholder="Select transporter"
              loading={loading.transporters}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverProfile;